import React, { useState, useEffect } from "react";
//import Link from react-router-dom;
import { Table, Spinner } from "react-bootstrap";
import RespIm from "./RespIm";
import "bootstrap/dist/css/bootstrap.min.css";

export default function ListaVideos(props) {
  const [dat, setDat] = useState({
    Lista: [],
    dataLoaded: false,
    videos: false,
  });
  const [valToken, setvalToken] = useState(true);
  const loadData = () => {
    fetchVideos()
      .then((json) => {
        switch (json.status) {
          case 401:
            setvalToken(false);
            break;
          case 200:
            setDat({ Lista: json.data, dataLoaded: true, videos: true });
            break;
          case 201:
            setDat({ Lista: [], dataLoaded: true, videos: false });
            break;
          default:
            alert(
              "Error conectandose a la base de datos (" +
                json.status +
                "): " +
                json.message
            );
            break;
        }
      })
      .catch((error) => {
        setDat({ Lista: [], dataLoaded: true, videos: false });
        alert(error);
      });
  };
  useEffect(() => {
    loadData();
  }, []);

  if (valToken) {
    if (dat.dataLoaded) {
      if (dat.videos) {
        return (
          <div>
            <div style={{ textAlign: "center" }}>
              <a href="https://www.entrenamientopostural.com/">
                <RespIm
                  x0={1003}
                  y0={700}
                  x={300}
                  src={require("../images/Logo.png").default}
                />
              </a>
            </div>
            <div style={{ paddingLeft: "3%", paddingRight: "3%" }}>
              <h5> ¡Hola, {props.estado.data.nombre}!</h5>
              <p style={{ fontSize: "14px" }}>
                Ya podés acceder a tus talleres grabados.
                <br />
                Tomate tu tiempo para hacerlos prestando atención a las
                sensaciones corporales. Si hay algo que molesta o duele,
                acordate que siempre tenés la posibilidad de descansar. <br />
                Cualquier inquietud, podés escribirme por{" "}
                <a href="mailto:hola@entrenamientopostural.com">email</a> que
                con gusto te respondo.
                <br />
                <br /> Si querés agregar nuevos talleres de Posturalmente, podés
                hacerlo clickeando{" "}
                <a href="https://www.entrenamientopostural.com/talleres">
                  acá{" "}
                </a>
                <br />
                <br />
                ¡Que lo disfrutes!
                <br />
                <br />
                Posturalmente,
                <br />
                <br />
                Dalila.
                <br />
                <br />
              </p>
            </div>
            <div style={{ paddingLeft: "3%", paddingRight: "3%" }}>
              <Table striped bordered hover style={{ textAlign: "center" }}>
                <thead>
                  <tr>
                    <th>Nombre</th>
                    <th> Contenido</th>
                  </tr>
                </thead>
                <tbody>
                  {dat.Lista.map((dat) => (
                    <tr
                      onClick={() => {
                        videos(dat);
                      }}
                    >
                      <td>{dat.name}</td>
                      <td style={{ textAlign: "left" }}>{dat.details}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          </div>
        );
      } else {
        return (
          <div>
            <div style={{ textAlign: "center" }}>
              <RespIm
                x0={1003}
                y0={700}
                x={300}
                src={require("../images/Logo.png").default}
              />
            </div>
            <div style={{ paddingLeft: "3%", paddingRight: "3%" }}>
              <h5> ¡Hola, {props.estado.data.nombre}!</h5>
              <p style={{ fontSize: "14px" }}>
                Lamentablemente no tenés contenido disponible.
                <br /> Si querés agregar talleres de Posturalmente, podés
                hacerlo clickeando{" "}
                <a
                  target="_blank"
                  href="https://www.entrenamientopostural.com/talleres"
                >
                  acá{" "}
                </a>
                <br />
                <br />
              </p>
            </div>
          </div>
        );
      }
    } else {
      return (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            paddingTop: "10%",
          }}
        >
          <Spinner animation="border" variant="primary" />
        </div>
      );
    }
  } else {
    props.setEstado({ n: 1, data: {} });
    return null;
  }

  function videos(dat) {
    props.setEstado({
      n: 11,
      data: {
        nombre: props.estado.data.nombre,
        url: dat.url,
        vidName: dat.name,
        vidDetails: dat.details,
      },
    });
  }
  async function fetchVideos() {
    const response = await fetch(
      "https://entrenamientopostural.com/services/PHP/getVideos.php",
      {
        method: "POST",

        headers: {
          "Content-type": "application/x-www-form-urlencoded; charset=UTF-8",
        },
        body: JSON.stringify({
          JWT: localStorage.getItem("Jwt"),
        }),
      }
    );
    if (response.status === 401) {
      return { status: 401, data: [], mesagge: "No autorizado" };
    } else if (response.status === 200) {
      const Output = await response.json();
      return Output;
    } else {
      return { status: response.status, data: [], mesagge: response.message };
    }
  }
}
